var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_170177",
    "data-name": "Grupo 170177",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.575,
    height: 34.655,
    viewBox: "0 0 36.575 34.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150852",
    "data-name": "Rect\\xE1ngulo 150852",
    width: 36.575,
    height: 34.655,
    fill: "#f3f2ee"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170175",
    "data-name": "Grupo 170175",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_86233",
    "data-name": "Trazado 86233",
    d: "M4.07,15.5,18,6.925a.954.954,0,0,1,1.012.006l0,0,13.574,8.625a.955.955,0,0,1,.444.808V29.869a4.794,4.794,0,0,1-4.786,4.786H24.432a1.909,1.909,0,0,1-1.353-.562l-.066-.072a1.958,1.958,0,0,1-.312-.467V23.374A1.082,1.082,0,0,0,21.622,22.3H14.953a1.082,1.082,0,0,0-1.079,1.079V33.557a1.92,1.92,0,0,1-1.731,1.1H8.327a4.793,4.793,0,0,1-4.786-4.786V16.361A.957.957,0,0,1,4.07,15.5M.88,10.915A1.906,1.906,0,0,0,0,12.523v2.886H0a.954.954,0,0,0,1.455.812L18.391,5.715,35.048,16.179a.958.958,0,0,0,1.527-.77v-2.89a1.893,1.893,0,0,0-.193-.84l-.036-.073a1.907,1.907,0,0,0-.643-.688L32.768,9l-.022-6.028a1.916,1.916,0,0,0-1.911-1.911H27a1.907,1.907,0,0,0-1.349.561l0,0a1.907,1.907,0,0,0-.561,1.349V4L19.434.312A1.9,1.9,0,0,0,17.358.305Z",
    transform: "translate(0 0)",
    fill: "#f3f2ee",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.86f96f110f633aa82210ce38bf43d6e8.svg";
export { ForwardRef as ReactComponent };